import { Cookies, LocalStorage } from 'core-lib/constants/storage';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import useMoengageLoad from '../../hooks/useMoengageLoad';
import { useProfile } from '../../hooks/useProfile';
import { getCookieValue } from '../../utils/cookie';
import { isParkPlusWebView } from '../../utils/source';
import { isServer } from '../../utils/utils';
import { flushMoengageEvents } from '../../utils/eventTracking';

const EMSThreshold = 15 * 60 * 1000;

export const QueuedEvents = () => {
  const [isMoengageLoaded] = useMoengageLoad();
  const { isAuthenticated, phoneNumber, isProfileLoaded, fullName, email } = useProfile();

  const addSessionTracker = () => {
    const obj = {
      created_at: Date.now(),
      session_id: uuid(),
    };
    localStorage.setItem(LocalStorage.SessionTracker, JSON.stringify(obj));
  };

  const checkSessionTracker = () => {
    if (!isParkPlusWebView()) {
      const sessionTracker = localStorage.getItem(LocalStorage.SessionTracker);
      if (!sessionTracker) {
        addSessionTracker();
      } else {
        const obj = JSON.parse(sessionTracker);
        // if diff > threshold, create and add new object to localStorage
        if (dayjs().diff(dayjs(obj.created_at)) >= EMSThreshold) {
          addSessionTracker();
        }
      }
    }
  };

  useEffect(() => {
    checkSessionTracker();
  }, []);

  useEffect(() => {
    if (isMoengageLoaded) {
      flushMoengageEvents();
    }
  }, [isMoengageLoaded]);

  useEffect(() => {
    if (isAuthenticated && isMoengageLoaded && isProfileLoaded) {
      const mobile = phoneNumber || getCookieValue(Cookies.AuthPhoneNo) || '';
      // @ts-ignore
      if (!isServer() && global.Moengage && mobile) {
        // @ts-ignore
        global.Moengage.add_unique_user_id(mobile);
        // @ts-ignore
        global.Moengage.add_mobile(mobile);
        // @ts-ignore
        global.Moengage.add_user_name(fullName);
        // @ts-ignore
        global.Moengage.add_email(email);
      }
    }
  }, [isAuthenticated, isProfileLoaded, isMoengageLoaded]);

  return null;
};
